import {
    createImage,
    getImageProps,
} from '../../../../commons/images';

import {
    computeLogoProps,
    withDefaultBanner,
    formalize,
} from '../../widget/actions/injectDefaults';

async function setupDynamicWidget (widget) {
    if (this.widget) {
        let imageProps = {};
       
        if (this.widget.logo) {
            const image = await createImage(this.widget.logo);
            computeLogoProps(this.widget, image);
            console.log('setupDynamicWidget() ', image);
            if (this.widget.logo.indexOf('ecal-logo-round') !== -1) {
                imageProps.logoWidth = 80;
                imageProps.logoHeight = 80;
                imageProps.logoAspectRatio = '1:1';
            } else {
                imageProps = getImageProps(image);
            }

            if (image.url) {
                // will only be added if virtual url is created..
                imageProps.logo = image.url;
                imageProps.logoWidth = 80;
                imageProps.logoHeight = 80;
                imageProps.logoAspectRatio = '1:1';
                imageProps.logoShadow = true;
                imageProps.logoShape = 'round';
            }
        }

        // check regression for the banners and logo
        let newData = this.widget;
        if (!newData?.banner_type || !newData?.banner_url) {
            newData = withDefaultBanner(newData);
        }

        this.widget = formalize(newData);

        this.widget = {
            ...this.widget,
            ...widget,
            ...imageProps,
        };
        console.log('setupDynamicWidget()  this.widget: ', this.widget);
    }
}

export default setupDynamicWidget;
